import { render, staticRenderFns } from "./UserDashboardProductsListItem.vue?vue&type=template&id=6f9d03e1&scoped=true&"
import script from "./UserDashboardProductsListItem.vue?vue&type=script&lang=js&"
export * from "./UserDashboardProductsListItem.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardProductsListItem.vue?vue&type=style&index=0&id=6f9d03e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d03e1",
  null
  
)

export default component.exports